// extracted by mini-css-extract-plugin
export var language = "language-module--language--2SjEw";
export var languageIcon = "language-module--language-icon--2QlH8";
export var active = "language-module--active--ZcIlu";
export var languageMenu = "language-module--language-menu--uHZ6N";
export var localeShort = "language-module--locale-short--3j89x";
export var scrolled = "language-module--scrolled--1F9nQ";
export var localeFull = "language-module--locale-full--3is5Q";